import { call, put, takeLatest, all, fork, select } from "redux-saga/effects";
import * as actions from "../actions/types";
import axios from "../../utils/axios";
import _ from "lodash";
import * as urls from "../../utils/urls";
import { isEmpty, getCookie } from "../../utils/common";
import { toggleBackDrop } from "../actions/commonAction";

//Next Stage API
function nextStageApi(param) {
  console.log("NEST STAGE SAGA", param);
  return axios.request({
    method: "post",
    url: `${process.env.REACT_APP_API_BASE_URL}${urls.NEXT_STAGE_URL}`,
    data: param,
  });
}

// Next Stage effect

export function* nextStageActionEffect(nextStage) {
  const { payload, resolve, reject } = nextStage;
  console.log("nextStage444343", nextStage);

  try {
    // yield put(toggleBackDrop(true));
    const { data } = yield call(nextStageApi, payload);
    // yield put(toggleBackDrop(false));
    if (!isEmpty(data)) {
      if (resolve) resolve(data);
      console.log("nextStageAction22", data);
      return yield put({
        type: actions.NEXT_STAGE_SUCCESS,
        data,
      });
    } else {
      yield put(toggleBackDrop(false));
      reject(data);
    }
  } catch (e) {
    yield put(toggleBackDrop(false));
    if (reject) reject(e);
    console.log("nextStageActionError", e);

    return yield put({
      type: actions.NEXT_STAGE_ERROR,
      e,
    });
  }
}
//Next Stage watcher
export function* nextStageActionWatcher() {
  yield takeLatest(actions.NEXT_STAGE, nextStageActionEffect);
}

export default function* rootSaga() {
  yield all([fork(nextStageActionWatcher)]);
}
